import React from "react";
import { useTranslation } from "react-i18next";
import { formatNumber, formatPhoneNumber } from "../../../utils/formatNumber";
import { Customer } from "../../../types/modules/admin/customer.type";
import DateTimeText from "../../ui/DateTimeText";

export default function CustomerBasicInfo({ customer }: { customer: Customer }) {
  const { t } = useTranslation();

  return (
    <div className="space-y-3">
      <p>📧 {t("customer_detail.email")}: {customer.email}</p>
      <p>📱 {t("customer_detail.phone")}: {formatPhoneNumber(customer.phone??"")}</p>
      <p>💰 {t("customer_detail.walletBalance")}: {formatNumber(customer.walletBalance)} {t("customer_detail.currency")}</p>
      <p>⭐ {t("customer_detail.points")}: {formatNumber(customer.points)}</p>
      <p>
        ⏰ {t("customer_detail.lastActive")}:{" "}
        <DateTimeText date={customer.lastActive??""}/>
      </p>
      <p className=" capitalize">
        👀 {t("lastLogin")}:{" "}
        <DateTimeText date={customer.lastLoginAt??""}/>
      </p>
      <p>
  📅 {t("registration_date")}: <DateTimeText date={customer.createdAt ?? ""} />
      </p>
    </div>
  );
}
